<template>
    <div class="d-flex z-clickable" @click.stop="toggle">
        <v-checkbox dense hide-details :input-value="iselected" color="primary" style="margin-top: 0px; padding-top: 0px; height: 32px" />
        <v-icon v-if="icon" class="mr-2 mt-n2" :color="color">
            {{icon}}
        </v-icon>
        <v-avatar v-else :color="color" class="mr-2 mt-1" size="20" >
            <v-auto-img v-if="image" :src="image" />
        </v-avatar>
        <span class="mr-2">{{name}}</span>
    </div>
</template>

<script>
export default {
    name: 'zoezi-filter-button-row',

    props: {
        value: {
            type: Boolean
        },
        name: {
            type: String,
        },
        image: {
            type: String,
        },
        color: {
            type: String,
            default: 'primary'
        },
        icon: {
            type: String
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.iselected = value;
            }
        }
    },

    data: () => ({
        iselected: false
    }),

    methods: {
        toggle() {
            this.iselected = !this.iselected;
            this.$emit('input', this.iselected);
        }
    }
}
</script>
